import { graphql } from 'parkdepot-shared/gql'

const B2C_GET_CHECKOUT_SESSION = graphql(`
    query B2CGetCheckoutSession(
        $order_id: String!
        $selected_parking_tariff: String
        $parking_context_uuid: String
        $email: String
        $language: String
    ) {
        b2c_checkout(
            order_id: $order_id
            email: $email
            language: $language
            selected_parking_tariff: $selected_parking_tariff
            parking_context_uuid: $parking_context_uuid
        ) {
            adyen_id
            adyen_session_data
        }
    }
`)

export default B2C_GET_CHECKOUT_SESSION
